import { Log } from '../AuxillaryService/Log';
import { stopCurrentDisplay } from '../Display';
import { NotImplementedError, platform, supportsPlayerControl } from '../Platform';

export async function signageRebootSystem(): Promise<void> {
    const thePlatform = platform();

    if (!supportsPlayerControl(thePlatform)) {
        throw new NotImplementedError('This platform does not support rebooting the OS.');
    }

    try {
        stopCurrentDisplay();
        return await thePlatform.rebootSystem();
    } catch (err) {
        if (err instanceof Error) {
            Log.Error('Failed to reboot system: ' + err.toString(), null, __fileline);
        }
        throw err;
    }
}
